module.exports = __webpack_public_path__ + "img/ricelog_pinicon_070.d3e509e5.png";